export default __webpack_public_path__ + "static/media/apple-pay.8027c86e.svg";